var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/warning-npm-3.0.0-125973e5cc-10.zip/node_modules/warning/browser.js
var require_browser = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/warning-npm-3.0.0-125973e5cc-10.zip/node_modules/warning/browser.js"(exports, module) {
    "use strict";
    var warning = function() {
    };
    if (true) {
      warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for (var key = 2; key < len; key++) {
          args[key - 2] = arguments[key];
        }
        if (format === void 0) {
          throw new Error(
            "`warning(condition, format, ...args)` requires a warning message argument"
          );
        }
        if (format.length < 10 || /^[s\W]*$/.test(format)) {
          throw new Error(
            "The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + format
          );
        }
        if (!condition) {
          var argIndex = 0;
          var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
          });
          if (typeof console !== "undefined") {
            console.error(message);
          }
          try {
            throw new Error(message);
          } catch (x) {
          }
        }
      };
    }
    module.exports = warning;
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/invariant-npm-2.2.4-717fbdb119-10.zip/node_modules/invariant/browser.js
var require_browser2 = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/invariant-npm-2.2.4-717fbdb119-10.zip/node_modules/invariant/browser.js"(exports, module) {
    "use strict";
    var invariant = function(condition, format, a, b, c, d, e, f) {
      if (true) {
        if (format === void 0) {
          throw new Error("invariant requires an error message argument");
        }
      }
      if (!condition) {
        var error;
        if (format === void 0) {
          error = new Error(
            "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
          );
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(
            format.replace(/%s/g, function() {
              return args[argIndex++];
            })
          );
          error.name = "Invariant Violation";
        }
        error.framesToPop = 1;
        throw error;
      }
    };
    module.exports = invariant;
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/resolve-pathname-npm-2.2.0-eb7d6b6716-10.zip/node_modules/resolve-pathname/cjs/index.js
var require_cjs = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/resolve-pathname-npm-2.2.0-eb7d6b6716-10.zip/node_modules/resolve-pathname/cjs/index.js"(exports, module) {
    "use strict";
    exports.__esModule = true;
    function isAbsolute(pathname) {
      return pathname.charAt(0) === "/";
    }
    function spliceOne(list, index) {
      for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
        list[i] = list[k];
      }
      list.pop();
    }
    function resolvePathname(to) {
      var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      var toParts = to && to.split("/") || [];
      var fromParts = from && from.split("/") || [];
      var isToAbs = to && isAbsolute(to);
      var isFromAbs = from && isAbsolute(from);
      var mustEndAbs = isToAbs || isFromAbs;
      if (to && isAbsolute(to)) {
        fromParts = toParts;
      } else if (toParts.length) {
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
      }
      if (!fromParts.length) return "/";
      var hasTrailingSlash = void 0;
      if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
      } else {
        hasTrailingSlash = false;
      }
      var up = 0;
      for (var i = fromParts.length; i >= 0; i--) {
        var part = fromParts[i];
        if (part === ".") {
          spliceOne(fromParts, i);
        } else if (part === "..") {
          spliceOne(fromParts, i);
          up++;
        } else if (up) {
          spliceOne(fromParts, i);
          up--;
        }
      }
      if (!mustEndAbs) for (; up--; up) {
        fromParts.unshift("..");
      }
      if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
      var result = fromParts.join("/");
      if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
      return result;
    }
    exports.default = resolvePathname;
    module.exports = exports["default"];
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/value-equal-npm-0.4.0-b9f7bc27f7-10.zip/node_modules/value-equal/cjs/index.js
var require_cjs2 = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/value-equal-npm-0.4.0-b9f7bc27f7-10.zip/node_modules/value-equal/cjs/index.js"(exports, module) {
    "use strict";
    exports.__esModule = true;
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function valueEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (Array.isArray(a)) {
        return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
          return valueEqual(item, b[index]);
        });
      }
      var aType = typeof a === "undefined" ? "undefined" : _typeof2(a);
      var bType = typeof b === "undefined" ? "undefined" : _typeof2(b);
      if (aType !== bType) return false;
      if (aType === "object") {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
          return valueEqual(a[key], b[key]);
        });
      }
      return false;
    }
    exports.default = valueEqual;
    module.exports = exports["default"];
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/PathUtils.js
var require_PathUtils = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/PathUtils.js"(exports) {
    "use strict";
    exports.__esModule = true;
    var addLeadingSlash2 = exports.addLeadingSlash = function addLeadingSlash3(path) {
      return path.charAt(0) === "/" ? path : "/" + path;
    };
    var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash2(path) {
      return path.charAt(0) === "/" ? path.substr(1) : path;
    };
    var hasBasename = exports.hasBasename = function hasBasename2(path, prefix) {
      return new RegExp("^" + prefix + "(\\/|\\?|#|$)", "i").test(path);
    };
    var stripBasename2 = exports.stripBasename = function stripBasename3(path, prefix) {
      return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
    };
    var stripTrailingSlash2 = exports.stripTrailingSlash = function stripTrailingSlash3(path) {
      return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
    };
    var parsePath = exports.parsePath = function parsePath2(path) {
      var pathname = path || "/";
      var search = "";
      var hash = "";
      var hashIndex = pathname.indexOf("#");
      if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
      }
      var searchIndex = pathname.indexOf("?");
      if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
      }
      return {
        pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
      };
    };
    var createPath = exports.createPath = function createPath2(location) {
      var pathname = location.pathname, search = location.search, hash = location.hash;
      var path = pathname || "/";
      if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
      if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
      return path;
    };
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/LocationUtils.js
var require_LocationUtils = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/LocationUtils.js"(exports) {
    "use strict";
    exports.__esModule = true;
    exports.locationsAreEqual = exports.createLocation = void 0;
    var _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _resolvePathname = require_cjs();
    var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
    var _valueEqual = require_cjs2();
    var _valueEqual2 = _interopRequireDefault(_valueEqual);
    var _PathUtils = require_PathUtils();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var createLocation = exports.createLocation = function createLocation2(path, state, key, currentLocation) {
      var location = void 0;
      if (typeof path === "string") {
        location = (0, _PathUtils.parsePath)(path);
        location.state = state;
      } else {
        location = _extends2({}, path);
        if (location.pathname === void 0) location.pathname = "";
        if (location.search) {
          if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else {
          location.search = "";
        }
        if (location.hash) {
          if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else {
          location.hash = "";
        }
        if (state !== void 0 && location.state === void 0) location.state = state;
      }
      try {
        location.pathname = decodeURI(location.pathname);
      } catch (e) {
        if (e instanceof URIError) {
          throw new URIError('Pathname "' + location.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.');
        } else {
          throw e;
        }
      }
      if (key) location.key = key;
      if (currentLocation) {
        if (!location.pathname) {
          location.pathname = currentLocation.pathname;
        } else if (location.pathname.charAt(0) !== "/") {
          location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
        }
      } else {
        if (!location.pathname) {
          location.pathname = "/";
        }
      }
      return location;
    };
    var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual2(a, b) {
      return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
    };
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/createTransitionManager.js
var require_createTransitionManager = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/createTransitionManager.js"(exports) {
    "use strict";
    exports.__esModule = true;
    var _warning = require_browser();
    var _warning2 = _interopRequireDefault(_warning);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var createTransitionManager = function createTransitionManager2() {
      var prompt = null;
      var setPrompt = function setPrompt2(nextPrompt) {
        (0, _warning2.default)(prompt == null, "A history supports only one prompt at a time");
        prompt = nextPrompt;
        return function() {
          if (prompt === nextPrompt) prompt = null;
        };
      };
      var confirmTransitionTo = function confirmTransitionTo2(location, action, getUserConfirmation2, callback) {
        if (prompt != null) {
          var result = typeof prompt === "function" ? prompt(location, action) : prompt;
          if (typeof result === "string") {
            if (typeof getUserConfirmation2 === "function") {
              getUserConfirmation2(result, callback);
            } else {
              (0, _warning2.default)(false, "A history needs a getUserConfirmation function in order to use a prompt message");
              callback(true);
            }
          } else {
            callback(result !== false);
          }
        } else {
          callback(true);
        }
      };
      var listeners = [];
      var appendListener = function appendListener2(fn) {
        var isActive = true;
        var listener = function listener2() {
          if (isActive) fn.apply(void 0, arguments);
        };
        listeners.push(listener);
        return function() {
          isActive = false;
          listeners = listeners.filter(function(item) {
            return item !== listener;
          });
        };
      };
      var notifyListeners = function notifyListeners2() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        listeners.forEach(function(listener) {
          return listener.apply(void 0, args);
        });
      };
      return {
        setPrompt,
        confirmTransitionTo,
        appendListener,
        notifyListeners
      };
    };
    exports.default = createTransitionManager;
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/DOMUtils.js
var require_DOMUtils = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/DOMUtils.js"(exports) {
    "use strict";
    exports.__esModule = true;
    var canUseDOM = exports.canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var addEventListener = exports.addEventListener = function addEventListener2(node, event, listener) {
      return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent("on" + event, listener);
    };
    var removeEventListener = exports.removeEventListener = function removeEventListener2(node, event, listener) {
      return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent("on" + event, listener);
    };
    var getConfirmation = exports.getConfirmation = function getConfirmation2(message, callback) {
      return callback(window.confirm(message));
    };
    var supportsHistory = exports.supportsHistory = function supportsHistory2() {
      var ua = window.navigator.userAgent;
      if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
      return window.history && "pushState" in window.history;
    };
    var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange2() {
      return window.navigator.userAgent.indexOf("Trident") === -1;
    };
    var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash2() {
      return window.navigator.userAgent.indexOf("Firefox") === -1;
    };
    var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent2(event) {
      return event.state === void 0 && navigator.userAgent.indexOf("CriOS") === -1;
    };
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/createBrowserHistory.js
var require_createBrowserHistory = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/createBrowserHistory.js"(exports) {
    "use strict";
    exports.__esModule = true;
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _warning = require_browser();
    var _warning2 = _interopRequireDefault(_warning);
    var _invariant = require_browser2();
    var _invariant2 = _interopRequireDefault(_invariant);
    var _LocationUtils = require_LocationUtils();
    var _PathUtils = require_PathUtils();
    var _createTransitionManager = require_createTransitionManager();
    var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
    var _DOMUtils = require_DOMUtils();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var PopStateEvent = "popstate";
    var HashChangeEvent = "hashchange";
    var getHistoryState = function getHistoryState2() {
      try {
        return window.history.state || {};
      } catch (e) {
        return {};
      }
    };
    var createBrowserHistory2 = function createBrowserHistory3() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      (0, _invariant2.default)(_DOMUtils.canUseDOM, "Browser history needs a DOM");
      var globalHistory = window.history;
      var canUseHistory = (0, _DOMUtils.supportsHistory)();
      var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
      var _props$forceRefresh = props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = props.getUserConfirmation, getUserConfirmation2 = _props$getUserConfirm === void 0 ? _DOMUtils.getConfirmation : _props$getUserConfirm, _props$keyLength = props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
      var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : "";
      var getDOMLocation = function getDOMLocation2(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
        return (0, _LocationUtils.createLocation)(path, state, key);
      };
      var createKey = function createKey2() {
        return Math.random().toString(36).substr(2, keyLength);
      };
      var transitionManager = (0, _createTransitionManager2.default)();
      var setState = function setState2(nextState) {
        _extends2(history2, nextState);
        history2.length = globalHistory.length;
        transitionManager.notifyListeners(history2.location, history2.action);
      };
      var handlePopState = function handlePopState2(event) {
        if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
        handlePop(getDOMLocation(event.state));
      };
      var handleHashChange = function handleHashChange2() {
        handlePop(getDOMLocation(getHistoryState()));
      };
      var forceNextPop = false;
      var handlePop = function handlePop2(location) {
        if (forceNextPop) {
          forceNextPop = false;
          setState();
        } else {
          var action = "POP";
          transitionManager.confirmTransitionTo(location, action, getUserConfirmation2, function(ok) {
            if (ok) {
              setState({ action, location });
            } else {
              revertPop(location);
            }
          });
        }
      };
      var revertPop = function revertPop2(fromLocation) {
        var toLocation = history2.location;
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
          forceNextPop = true;
          go2(delta);
        }
      };
      var initialLocation = getDOMLocation(getHistoryState());
      var allKeys = [initialLocation.key];
      var createHref = function createHref2(location) {
        return basename + (0, _PathUtils.createPath)(location);
      };
      var push2 = function push3(path, state) {
        (0, _warning2.default)(!((typeof path === "undefined" ? "undefined" : _typeof2(path)) === "object" && path.state !== void 0 && state !== void 0), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history2.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation2, function(ok) {
          if (!ok) return;
          var href = createHref(location);
          var key = location.key, state2 = location.state;
          if (canUseHistory) {
            globalHistory.pushState({ key, state: state2 }, null, href);
            if (forceRefresh) {
              window.location.href = href;
            } else {
              var prevIndex = allKeys.indexOf(history2.location.key);
              var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
              nextKeys.push(location.key);
              allKeys = nextKeys;
              setState({ action, location });
            }
          } else {
            (0, _warning2.default)(state2 === void 0, "Browser history cannot push state in browsers that do not support HTML5 history");
            window.location.href = href;
          }
        });
      };
      var replace2 = function replace3(path, state) {
        (0, _warning2.default)(!((typeof path === "undefined" ? "undefined" : _typeof2(path)) === "object" && path.state !== void 0 && state !== void 0), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history2.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation2, function(ok) {
          if (!ok) return;
          var href = createHref(location);
          var key = location.key, state2 = location.state;
          if (canUseHistory) {
            globalHistory.replaceState({ key, state: state2 }, null, href);
            if (forceRefresh) {
              window.location.replace(href);
            } else {
              var prevIndex = allKeys.indexOf(history2.location.key);
              if (prevIndex !== -1) allKeys[prevIndex] = location.key;
              setState({ action, location });
            }
          } else {
            (0, _warning2.default)(state2 === void 0, "Browser history cannot replace state in browsers that do not support HTML5 history");
            window.location.replace(href);
          }
        });
      };
      var go2 = function go3(n) {
        globalHistory.go(n);
      };
      var goBack = function goBack2() {
        return go2(-1);
      };
      var goForward = function goForward2() {
        return go2(1);
      };
      var listenerCount = 0;
      var checkDOMListeners = function checkDOMListeners2(delta) {
        listenerCount += delta;
        if (listenerCount === 1) {
          (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
          if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
          (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
          if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
        }
      };
      var isBlocked = false;
      var block = function block2() {
        var prompt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
          checkDOMListeners(1);
          isBlocked = true;
        }
        return function() {
          if (isBlocked) {
            isBlocked = false;
            checkDOMListeners(-1);
          }
          return unblock();
        };
      };
      var listen = function listen2(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
          checkDOMListeners(-1);
          unlisten();
        };
      };
      var history2 = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref,
        push: push2,
        replace: replace2,
        go: go2,
        goBack,
        goForward,
        block,
        listen
      };
      return history2;
    };
    exports.default = createBrowserHistory2;
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/createMemoryHistory.js
var require_createMemoryHistory = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-history-npm-1.0.0-78ab3ea4cc-10.zip/node_modules/rudy-history/createMemoryHistory.js"(exports) {
    "use strict";
    exports.__esModule = true;
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _warning = require_browser();
    var _warning2 = _interopRequireDefault(_warning);
    var _invariant = require_browser2();
    var _invariant2 = _interopRequireDefault(_invariant);
    var _PathUtils = require_PathUtils();
    var _LocationUtils = require_LocationUtils();
    var _createTransitionManager = require_createTransitionManager();
    var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var clamp = function clamp2(n, lowerBound, upperBound) {
      return Math.min(Math.max(n, lowerBound), upperBound);
    };
    var hasConfirm = !!(typeof window !== "undefined" && typeof window.confirm !== "undefined");
    var getConfirmation = function getConfirmation2(message, callback) {
      (0, _invariant2.default)(hasConfirm, "Environment needs a window + window.confirm function. You can provideyour own confirmation UI via the getUserConfirmation option.");
      return callback(window.confirm(message));
    };
    var createMemoryHistory2 = function createMemoryHistory3() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var _props$getUserConfirm = props.getUserConfirmation, getUserConfirmation2 = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$initialEntries = props.initialEntries, initialEntries = _props$initialEntries === void 0 ? ["/"] : _props$initialEntries, _props$initialIndex = props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
      var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : "";
      var transitionManager = (0, _createTransitionManager2.default)();
      var setState = function setState2(nextState) {
        _extends2(history2, nextState);
        history2.length = history2.entries.length;
        transitionManager.notifyListeners(history2.location, history2.action);
      };
      var createKey = function createKey2() {
        return Math.random().toString(36).substr(2, keyLength);
      };
      var index = clamp(initialIndex, 0, initialEntries.length - 1);
      var getStrippedPath = function getStrippedPath2(path) {
        return basename ? (0, _PathUtils.stripBasename)(path, basename) : path;
      };
      var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? (0, _LocationUtils.createLocation)(getStrippedPath(entry), void 0, createKey()) : (0, _LocationUtils.createLocation)(getStrippedPath(entry), void 0, entry.key || createKey());
      });
      var createHref = function createHref2(location) {
        return basename + (0, _PathUtils.createPath)(location);
      };
      var push2 = function push3(path, state) {
        (0, _warning2.default)(!((typeof path === "undefined" ? "undefined" : _typeof2(path)) === "object" && path.state !== void 0 && state !== void 0), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = (0, _LocationUtils.createLocation)(getStrippedPath(path), state, createKey(), history2.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation2, function(ok) {
          if (!ok) return;
          var prevIndex = history2.index;
          var nextIndex = prevIndex + 1;
          var nextEntries = history2.entries.slice(0);
          if (nextEntries.length > nextIndex) {
            nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
          } else {
            nextEntries.push(location);
          }
          setState({
            action,
            location,
            index: nextIndex,
            entries: nextEntries
          });
        });
      };
      var replace2 = function replace3(path, state) {
        (0, _warning2.default)(!((typeof path === "undefined" ? "undefined" : _typeof2(path)) === "object" && path.state !== void 0 && state !== void 0), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = (0, _LocationUtils.createLocation)(getStrippedPath(path), state, createKey(), history2.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation2, function(ok) {
          if (!ok) return;
          history2.entries[history2.index] = location;
          setState({ action, location });
        });
      };
      var go2 = function go3(n) {
        var nextIndex = clamp(history2.index + n, 0, history2.entries.length - 1);
        var action = "POP";
        var location = history2.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation2, function(ok) {
          if (ok) {
            setState({
              action,
              location,
              index: nextIndex
            });
          } else {
            setState();
          }
        });
      };
      var goBack = function goBack2() {
        return go2(-1);
      };
      var goForward = function goForward2() {
        return go2(1);
      };
      var canGo2 = function canGo3(n) {
        var nextIndex = history2.index + n;
        return nextIndex >= 0 && nextIndex < history2.entries.length;
      };
      var block = function block2() {
        var prompt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return transitionManager.setPrompt(prompt);
      };
      var listen = function listen2(listener) {
        return transitionManager.appendListener(listener);
      };
      var history2 = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index,
        entries,
        createHref,
        push: push2,
        replace: replace2,
        go: go2,
        goBack,
        goForward,
        canGo: canGo2,
        block,
        listen
      };
      return history2;
    };
    exports.default = createMemoryHistory2;
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/isarray-npm-0.0.1-92e37e0a70-10.zip/node_modules/isarray/index.js
var require_isarray = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/isarray-npm-0.0.1-92e37e0a70-10.zip/node_modules/isarray/index.js"(exports, module) {
    module.exports = Array.isArray || function(arr) {
      return Object.prototype.toString.call(arr) == "[object Array]";
    };
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/path-to-regexp-npm-1.8.0-a1904f5c44-10.zip/node_modules/path-to-regexp/index.js
var require_path_to_regexp = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/path-to-regexp-npm-1.8.0-a1904f5c44-10.zip/node_modules/path-to-regexp/index.js"(exports, module) {
    var isarray = require_isarray();
    module.exports = pathToRegexp;
    module.exports.parse = parse;
    module.exports.compile = compile;
    module.exports.tokensToFunction = tokensToFunction;
    module.exports.tokensToRegExp = tokensToRegExp;
    var PATH_REGEXP = new RegExp([
      // Match escaped characters that would otherwise appear in future matches.
      // This allows the user to escape special characters that won't transform.
      "(\\\\.)",
      // Match Express-style parameters and un-named parameters with a prefix
      // and optional suffixes. Matches appear as:
      //
      // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
      // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
      // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
      "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
    ].join("|"), "g");
    function parse(str, options) {
      var tokens = [];
      var key = 0;
      var index = 0;
      var path = "";
      var defaultDelimiter = options && options.delimiter || "/";
      var res;
      while ((res = PATH_REGEXP.exec(str)) != null) {
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        if (escaped) {
          path += escaped[1];
          continue;
        }
        var next2 = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        if (path) {
          tokens.push(path);
          path = "";
        }
        var partial = prefix != null && next2 != null && next2 !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
          name: name || key++,
          prefix: prefix || "",
          delimiter,
          optional,
          repeat,
          partial,
          asterisk: !!asterisk,
          pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : "[^" + escapeString(delimiter) + "]+?"
        });
      }
      if (index < str.length) {
        path += str.substr(index);
      }
      if (path) {
        tokens.push(path);
      }
      return tokens;
    }
    function compile(str, options) {
      return tokensToFunction(parse(str, options), options);
    }
    function encodeURIComponentPretty(str) {
      return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
      });
    }
    function encodeAsterisk(str) {
      return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
      });
    }
    function tokensToFunction(tokens, options) {
      var matches = new Array(tokens.length);
      for (var i = 0; i < tokens.length; i++) {
        if (typeof tokens[i] === "object") {
          matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
        }
      }
      return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options2 = opts || {};
        var encode = options2.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for (var i2 = 0; i2 < tokens.length; i2++) {
          var token = tokens[i2];
          if (typeof token === "string") {
            path += token;
            continue;
          }
          var value = data[token.name];
          var segment;
          if (value == null) {
            if (token.optional) {
              if (token.partial) {
                path += token.prefix;
              }
              continue;
            } else {
              throw new TypeError('Expected "' + token.name + '" to be defined');
            }
          }
          if (isarray(value)) {
            if (!token.repeat) {
              throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
            }
            if (value.length === 0) {
              if (token.optional) {
                continue;
              } else {
                throw new TypeError('Expected "' + token.name + '" to not be empty');
              }
            }
            for (var j = 0; j < value.length; j++) {
              segment = encode(value[j]);
              if (!matches[i2].test(segment)) {
                throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
              }
              path += (j === 0 ? token.prefix : token.delimiter) + segment;
            }
            continue;
          }
          segment = token.asterisk ? encodeAsterisk(value) : encode(value);
          if (!matches[i2].test(segment)) {
            throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
          }
          path += token.prefix + segment;
        }
        return path;
      };
    }
    function escapeString(str) {
      return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
    }
    function escapeGroup(group) {
      return group.replace(/([=!:$\/()])/g, "\\$1");
    }
    function attachKeys(re, keys) {
      re.keys = keys;
      return re;
    }
    function flags(options) {
      return options && options.sensitive ? "" : "i";
    }
    function regexpToRegexp(path, keys) {
      var groups = path.source.match(/\((?!\?)/g);
      if (groups) {
        for (var i = 0; i < groups.length; i++) {
          keys.push({
            name: i,
            prefix: null,
            delimiter: null,
            optional: false,
            repeat: false,
            partial: false,
            asterisk: false,
            pattern: null
          });
        }
      }
      return attachKeys(path, keys);
    }
    function arrayToRegexp(path, keys, options) {
      var parts = [];
      for (var i = 0; i < path.length; i++) {
        parts.push(pathToRegexp(path[i], keys, options).source);
      }
      var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
      return attachKeys(regexp, keys);
    }
    function stringToRegexp(path, keys, options) {
      return tokensToRegExp(parse(path, options), keys, options);
    }
    function tokensToRegExp(tokens, keys, options) {
      if (!isarray(keys)) {
        options = /** @type {!Object} */
        keys || options;
        keys = [];
      }
      options = options || {};
      var strict = options.strict;
      var end = options.end !== false;
      var route = "";
      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (typeof token === "string") {
          route += escapeString(token);
        } else {
          var prefix = escapeString(token.prefix);
          var capture = "(?:" + token.pattern + ")";
          keys.push(token);
          if (token.repeat) {
            capture += "(?:" + prefix + capture + ")*";
          }
          if (token.optional) {
            if (!token.partial) {
              capture = "(?:" + prefix + "(" + capture + "))?";
            } else {
              capture = prefix + "(" + capture + ")?";
            }
          } else {
            capture = prefix + "(" + capture + ")";
          }
          route += capture;
        }
      }
      var delimiter = escapeString(options.delimiter || "/");
      var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
      if (!strict) {
        route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
      }
      if (end) {
        route += "$";
      } else {
        route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
      }
      return attachKeys(new RegExp("^" + route, flags(options)), keys);
    }
    function pathToRegexp(path, keys, options) {
      if (!isarray(keys)) {
        options = /** @type {!Object} */
        keys || options;
        keys = [];
      }
      options = options || {};
      if (path instanceof RegExp) {
        return regexpToRegexp(
          path,
          /** @type {!Array} */
          keys
        );
      }
      if (isarray(path)) {
        return arrayToRegexp(
          /** @type {!Array} */
          path,
          /** @type {!Array} */
          keys,
          options
        );
      }
      return stringToRegexp(
        /** @type {string} */
        path,
        /** @type {!Array} */
        keys,
        options
      );
    }
  }
});

// ../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-match-path-npm-0.3.0-aaded11e4e-10.zip/node_modules/rudy-match-path/dist/index.js
var require_dist = __commonJS({
  "../../../../../../../../../home/gitlab-runner/.yarn/berry/cache/rudy-match-path-npm-0.3.0-aaded11e4e-10.zip/node_modules/rudy-match-path/dist/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.compileParamsToPath = exports.compilePath = void 0;
    var _pathToRegexp = require_path_to_regexp();
    var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _toArray(arr) {
      return Array.isArray(arr) ? arr : Array.from(arr);
    }
    var patternCache = {};
    var cacheLimit = 1e4;
    var cacheCount = 0;
    var compilePath2 = exports.compilePath = function compilePath3(pattern) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var _options$end = options.end, end = _options$end === void 0 ? true : _options$end, _options$strict = options.strict, strict = _options$strict === void 0 ? false : _options$strict;
      var cacheKey = (end ? "t" : "f") + (strict ? "t" : "f");
      var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
      if (cache[pattern]) return cache[pattern];
      var keys = [];
      var re = (0, _pathToRegexp2.default)(pattern, keys, options);
      var compiledPattern = { re, keys };
      if (cacheCount < cacheLimit) {
        cache[pattern] = compiledPattern;
        cacheCount++;
      }
      return compiledPattern;
    };
    var toPathCache = {};
    var compileParamsToPath2 = exports.compileParamsToPath = function compileParamsToPath3(path) {
      var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var toPath = toPathCache[path] || _pathToRegexp2.default.compile(path);
      toPathCache[path] = toPath;
      return toPath(params);
    };
    var matchPath = function matchPath2(pathname) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (typeof options === "string") {
        options = { path: options, exact: false, strict: false };
      }
      var _options2 = options, _options$path = _options2.path, path = _options$path === void 0 ? "/" : _options$path, _options$exact = _options2.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict2 = _options2.strict, strict = _options$strict2 === void 0 ? false : _options$strict2;
      var _compilePath = compilePath2(path, { end: exact, strict }), re = _compilePath.re, keys = _compilePath.keys;
      var match = re.exec(pathname);
      if (!match) return null;
      var _match = _toArray(match), url = _match[0], values = _match.slice(1);
      var isExact = pathname === url;
      if (exact && !isExact) return null;
      return {
        path,
        // the path pattern used to match
        url: path === "/" && url === "" ? "/" : url,
        // the matched portion of the URL
        isExact,
        // whether or not we matched exactly
        params: keys.reduce(function(memo, key, index) {
          memo[key.name] = values[index];
          return memo;
        }, {})
      };
    };
    exports.default = matchPath;
  }
});

// src/routes.gen.ts
var ROUTE_CONFIG_MAP = {
  "/playground*": {
    path: "/playground*",
    flag: void 0,
    enabled: true
  },
  "/token-signin*": {
    path: "/token-signin*",
    flag: void 0,
    enabled: true
  },
  "/stocks": {
    path: "/stocks",
    flag: "next-migrate-stocks-page",
    enabled: void 0
  },
  "/stocks/:market/:sortBy(market-cap-large|market-cap-small|top-gainers|biggest-losers|growth|dividend-yield-high)?": {
    path: "/stocks/:market/:sortBy(market-cap-large|market-cap-small|top-gainers|biggest-losers|growth|dividend-yield-high)?",
    flag: "next-migrate-stocks-page",
    enabled: void 0
  },
  "/stocks/:market/:industry/:sortBy(market-cap-large|market-cap-small|top-gainers|biggest-losers|growth|dividend-yield-high)?": {
    path: "/stocks/:market/:industry/:sortBy(market-cap-large|market-cap-small|top-gainers|biggest-losers|growth|dividend-yield-high)?",
    flag: "next-migrate-stocks-page",
    enabled: void 0
  }
};

// ../locale/lib/index.js
var LOCALES = [
  "en",
  "es",
  "de",
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/connectRoutes.js
var import_createBrowserHistory = __toESM(require_createBrowserHistory());
var import_createMemoryHistory = __toESM(require_createMemoryHistory());
var import_PathUtils2 = __toESM(require_PathUtils());

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/pure-utils/pathToAction.js
var import_rudy_match_path = __toESM(require_dist());
var import_PathUtils = __toESM(require_PathUtils());

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/pure-utils/objectValues.js
var objectValues_default = function(routes) {
  return Object.keys(routes).map(function(key) {
    return routes[key];
  });
};

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/pure-utils/pathToAction.js
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var pathToAction_default = function(pathname, routesMap, serializer) {
  var basename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : getOptions().basename;
  var strict = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : getOptions().strict;
  var parts = pathname.split("?");
  var search = parts[1];
  var query = search && serializer && serializer.parse(search);
  var routes = objectValues_default(routesMap);
  var routeTypes = Object.keys(routesMap);
  pathname = basename ? (0, import_PathUtils.stripBasename)(parts[0], basename) : parts[0];
  var i = 0;
  var match = void 0;
  var keys = void 0;
  while (!match && i < routes.length) {
    var regPath = typeof routes[i] === "string" ? routes[i] : routes[i].path;
    if (!regPath) {
      i++;
      continue;
    }
    var _compilePath = (0, import_rudy_match_path.compilePath)(regPath, { strict }), re = _compilePath.re, k = _compilePath.keys;
    match = re.exec(pathname);
    keys = k;
    i++;
  }
  if (match) {
    i--;
    var capitalizedWords = _typeof(routes[i]) === "object" && routes[i].capitalizedWords;
    var coerceNumbers = _typeof(routes[i]) === "object" && routes[i].coerceNumbers;
    var fromPath = routes[i] && typeof routes[i].fromPath === "function" && routes[i].fromPath;
    var userMeta = _typeof(routes[i]) === "object" && routes[i].meta;
    var type = routeTypes[i];
    var payload = (keys || []).reduce(function(payload2, key, index) {
      var val = match && match[index + 1];
      if (typeof val === "string") {
        if (fromPath) {
          val = fromPath && fromPath(val, key.name);
        } else if (coerceNumbers && isNumber(val)) {
          val = parseFloat(val);
        } else if (capitalizedWords) {
          val = val.replace(/-/g, " ").replace(/\b\w/g, function(l) {
            return l.toUpperCase();
          });
        }
      }
      payload2[key.name] = val;
      return payload2;
    }, {});
    var _meta = _extends({}, userMeta ? { meta: userMeta } : {}, query ? { query } : {});
    return { type, payload, meta: _meta };
  }
  var meta = _extends({ notFoundPath: pathname }, query ? { query } : {});
  return { type: NOT_FOUND, payload: {}, meta };
};
var isNumber = function isNumber2(val) {
  return /^\d+$/.test(val);
};

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/pure-utils/canUseDom.js
var canUseDom_default = typeof window !== "undefined" && window.document && window.document.createElement;

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/pure-utils/actionToPath.js
var import_rudy_match_path2 = __toESM(require_dist());

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/connectRoutes.js
var _options = void 0;
var getOptions = function getOptions2() {
  return _options || {};
};

// ../../.yarn/__virtual__/redux-first-router-virtual-2037d9321b/8/home/gitlab-runner/.yarn/berry/cache/redux-first-router-npm-2.1.5-407ac70bb5-10.zip/node_modules/redux-first-router/dist/es/index.js
var NOT_FOUND = "@@redux-first-router/NOT_FOUND";

// src/routes.ts
var LOCALE_STRIP_PATH_REGEX = new RegExp(`^/(${LOCALES.join("|")})/`);
var isMigratedRoute = (path, checkFlag) => {
  try {
    const normalisedPath = path.split("?")[0].replace(/\/$/, "") || "/";
    const pathWithoutLocale = normalisedPath.replace(
      LOCALE_STRIP_PATH_REGEX,
      "/"
    );
    const action = pathToAction_default(
      pathWithoutLocale,
      ROUTE_CONFIG_MAP
    );
    if (action.type === NOT_FOUND) {
      return false;
    }
    const routeConfig = ROUTE_CONFIG_MAP[action.type];
    if (routeConfig?.flag !== void 0) {
      return checkFlag(routeConfig.flag);
    }
    return routeConfig.enabled ?? false;
  } catch (error) {
    return false;
  }
};
export {
  isMigratedRoute
};
